export enum RequestStatus {  
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  ABORT = "ABORT", 
}